import { render, staticRenderFns } from "./shiting.vue?vue&type=template&id=4f54cda6&scoped=true"
import script from "./shiting.vue?vue&type=script&lang=js"
export * from "./shiting.vue?vue&type=script&lang=js"
import style0 from "./shiting.vue?vue&type=style&index=0&id=4f54cda6&prod&lang=scss&scoped=true"
import style1 from "./shiting.vue?vue&type=style&index=1&id=4f54cda6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54cda6",
  null
  
)

export default component.exports